import type { History } from 'history';
import React from 'react';
import type { RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router';

export const RootHistoryContext = React.createContext<History | null>(null);

const RootHistoryContextProvider: React.FC<RouteComponentProps & { children: React.ReactNode }> = ({
  history,
  children
}) => <RootHistoryContext.Provider value={history}>{children}</RootHistoryContext.Provider>;

// @ts-ignore TODO apply patch to react types
export default withRouter(RootHistoryContextProvider);
